import UAParser  from 'ua-parser-js';
var parser = new UAParser();

const deviceInfo = (ua = null)=> {
    parser.setUA(ua);
    return parser.getResult();
}

export default deviceInfo;